<sui-modal #modal [isClosable]="false" size="large" (dismissed)="router.navigate(['/'])">
  <div class="header" i18n="@@app-subscribe-title">FIT-Newsletter abonnieren</div>
  @if (user) {
    <div class="content scrolling">
      <h3 class="ui header" i18n="@@register-modal-profile-settings">Profil Einstellungen: </h3>
      <app-user-profile-form #profileForm [editUser]="user" [simple]="true"></app-user-profile-form>
      <h3 class="ui header" i18n="@@register-modal-newsletter-settings">Newsletter Einstellungen: </h3>
      <app-user-newsletter-form #newsletterForm [editUser]="user" [simple]="true"></app-user-newsletter-form>
    </div>
    <div class="actions">
      <button id="cancel-logout-button" class="ui secondary button" (click)="keycloakService.logout()" i18n="@@register-modal-cancel">
        Abbruch & Logout
      </button>
      <button
        id="save-button"
        class="ui primary button"
        [disabled]="profileForm.userForm.invalid || newsletterForm.newsletterForm.invalid"
        (click)="finishRegistration(profileForm.submit(),newsletterForm.submit(), modal)"
        i18n="@@save"
      >
        Speichern
      </button>
    </div>
  }
</sui-modal>
